export type SortColumn = 'fileName' | 'clientName' | 'updatedAt' | 'downloadedAt';
export type SortDirection = 'asc' | 'desc';
export type DownloadableFile = {
  fileName: string;
  updatedAt: string;
  downloadedAt: string;
  downloadToken: string;
}
export type AccountantClient = { clientId: string, clientName: string};

export const downloadFromUrl = (window: Window & typeof globalThis, blob: Blob, fileName: string)=> {
  const url = window.URL.createObjectURL(blob);
  const a = window.document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}

export const sortAndReturn = (filteredFileList: DownloadableFile[], sortColumn: SortColumn | null, sortDirection: SortDirection) => {
  if (!sortColumn) {
    return filteredFileList;
  }
  const filteredFileListShallowCloned = [...filteredFileList]
  const direction = sortDirection === 'asc' ? 1 : -1;
  filteredFileListShallowCloned.sort((a, b) => {
    let valA: string | null;
    let valB: string | null;

    switch (sortColumn) {
      case 'fileName':
        valA = a.fileName?.toLowerCase() ?? '';
        valB = b.fileName?.toLowerCase() ?? '';
        break;
      case 'updatedAt':
        valA = a.updatedAt ?? '';
        valB = b.updatedAt ?? '';
        break;
      case 'downloadedAt':
        valA = a.downloadedAt ?? '';
        valB = b.downloadedAt ?? '';
        break;
      default:
        return 0;
    }

    if (valA < valB) return -1 * direction;
    if (valA > valB) return 1 * direction;
    return 0;
  });
  return filteredFileListShallowCloned;
}
